;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:tillamook-com":true});}catch(e){}}();import { useEffect, useState } from 'react';

function getVisibility() {
    if (typeof document === 'undefined') return true;
    return document.visibilityState;
}

function useDocumentVisibility() {
    let [documentVisibility, setDocumentVisibility] = useState(getVisibility());

    function handleVisibilityChange() {
        setDocumentVisibility(getVisibility());
    }

    useEffect(() => {
        window.addEventListener('visibilitychange', handleVisibilityChange);
        return () => {
            window.removeEventListener(
                'visibilitychange',
                handleVisibilityChange
            );
        };
    }, []);

    return documentVisibility;
}

export default useDocumentVisibility;
